var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$dataManager.getters.loading)?_c('div',{staticClass:"loading-container"},[_c('img',{staticClass:"loading",attrs:{"src":_vm.loading,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }